$(document).ready(function () {
  const addressesPattern = '/account/addresses';
  const ordersPattern = '/account/orders-list';

  if ($('#account-navigation')) {
    $('#account-navigation').find('.navigation-item').each(function () {
      const $link = $(this).find('a');
      const href = $link.attr('href');

      if (href === addressesPattern && window.location.href.indexOf(addressesPattern) > -1) {
        $link.addClass('active');
      } else if (href === ordersPattern && window.location.href.indexOf(ordersPattern) > -1) {
        $link.addClass('active');
      } else if (Boolean(window.location.pathname.match(href+'/?$'))) {
        $link.addClass('active');
      } else $link.removeClass('active');
    });
  }

  if ($('#account-menu')) {
    $('#account-menu').find('.navigation-item').each(function () {
      const href = $(this).attr('href');

      if (href === addressesPattern && window.location.href.indexOf(addressesPattern) > -1) {
        $(this).addClass('_active');
      } else if (href === ordersPattern && window.location.href.indexOf(ordersPattern) > -1) {
        $(this).addClass('_active');
      } else if (Boolean(window.location.pathname.match(href+'/?$'))) {
        $(this).addClass('_active');
      } else $(this).removeClass('active');
    });
  }

  if ($('#help-navigation')) {
    $('#help-navigation').find('.navigation-item').each(function () {
      const $link = $(this).find('a');
      const href = $link.attr('href');

      if (window.location.href.indexOf(href) > -1) {
        $link.addClass('active');
      } else $link.removeClass('active');
    });
  }

  if ($('#help-menu')) {
    $('#help-menu').find('.navigation-item').each(function () {
      const href = $(this).attr('href');

      if (window.location.href.indexOf(href) > -1) {
        $(this).addClass('_active');
      } else $(this).removeClass('active');
    });
  }

  if ($('#pages')) {
    $('#pages').find('.category-btn').each(function () {
      const href = $(this).attr('href');

      if (window.location.href.indexOf(href) > -1) {
        $(this).addClass('_active');
      } else $(this).removeClass('active');
    });
  }
});

$(document).on('click', (e) => {
  if ($(e.target).hasClass('navigation-burger')) {
    const $menu = $('#menu');

    const showMenu = (menuToOpen, navigationItemSelector) => {
      if ($menu) {
        $menu.find('.main-wrapper').addClass('_shown-second');
        $menu.find('.menu-second').css('display', 'none');
        $menu.find(`.menu-second_${menuToOpen}`).css('display', 'block');
        $menu.find('.button-back').css('display', 'block');
        $menu.find(navigationItemSelector).each(function () {
          const href = $(this).attr('href');

          if (window.location.href.indexOf(href) > -1) {
            $(this).addClass('_active');
          } else $(this).removeClass('active');
        });
      }
    }

    if ($menu) {
      if (
        window.location.href.indexOf('/returns') > -1 ||
        window.location.href.indexOf('/shopping-pintel-store') > -1 ||
        window.location.href.indexOf('/private') > -1 ||
        window.location.href.indexOf('/shipping-handling') > -1 ||
        window.location.href.indexOf('/managing-your-account') > -1 ||
        window.location.href.indexOf('/contacts') > -1
      ) {
        showMenu('help', '.navigation-item');
      }

      if (window.location.href.indexOf('/catalog') > -1) {
        showMenu('shop', '.category-btn');
      }
    }
  }

  if ($(e.target.closest('a')).data('navigate')) {
    const actionMenu = $(e.target.closest('.action-menu'));
    const navigationTarget = $(e.target.closest('a')).data('navigate');
    actionMenu.find('.main-wrapper').addClass('_shown-second');
    actionMenu.find('.menu-second').css('display', 'none');
    actionMenu.find(`.menu-second_${navigationTarget}`).css('display', 'block');
    actionMenu.find('.button-back').css('display', 'block');
  }
});
